/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Import_Csv_Label_FileInputs */



/**
* | output |
* | --- |
* | "CSV file" |
*
* @param {Datasets_Import_Csv_Label_FileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_import_csv_label_file = /** @type {((inputs?: Datasets_Import_Csv_Label_FileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Import_Csv_Label_FileInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("CSV-Datei")
	return /** @type {LocalizedString} */ ("CSV file")
});